import { fetchInstance } from '../utils/fetchInstance.ts';

export const getRoleCategories = async () => {
  return await fetchInstance.get<
    {
      roleCategoryId: string;
      name: string;
      createdAt: Date;
      updatedAt: Date;
      color: string;
      roles: {
        roleId: string;
        discordId: string;
        name: string;
        roleCategoryId: string;
        color: string;
      }[];
    }[]
  >('roles/categories');
};

export const getMyRoles = async () => {
  return await fetchInstance.get<
    {
      roleId: string;
      discordId: string;
      name: string;
      roleCategoryId: string;
      color: string;
    }[]
  >('roles/users/me');
};

export const updateMyRole = async (roleId: string, isAdd: boolean) => {
  return await fetchInstance.put('roles/users/me', {
    roleId,
    isAdd,
  });
};
